import React from 'react';
import ClientsContainer from "../containers/ClientsContainer";

const ClientsPage = () => {
    return (
        <div>
            <ClientsContainer/>
        </div>
    );
};

export default ClientsPage;